import {
    DropdownMenuTrigger,
    useDropdownMenuContext,
    DropdownMenuItem,
    type DropdownMenuItemProps
} from 'tradera/components/dropdown-menu2/dropdown-menu2';
import CheckIcon from 'tradera/blueprint/theme/icons2/check.svg?jsx';

import { OptionField, type OptionFieldProps } from './option-field';
import { classNames } from 'tradera/utils/class-names';

export type DropdownFieldProps = Omit<OptionFieldProps, 'isOpen'>;

export const DropdownField = ({
    title,
    valueText,
    wrapperClass,
    placeholder,
    disabled,
    error,
    truncateValueLeft = false,
    bottomBorder = true,
    ...props
}: DropdownFieldProps) => {
    const { isOpen } = useDropdownMenuContext();

    return (
        <DropdownMenuTrigger asChild {...props} disabled={disabled}>
            <OptionField
                {...{
                    title,
                    valueText,
                    wrapperClass,
                    placeholder,
                    isOpen,
                    disabled,
                    error,
                    bottomBorder,
                    truncateValueLeft
                }}
            />
        </DropdownMenuTrigger>
    );
};

type DropdownMenuItemSelectableProps = {
    text: string;
    before?: React.ReactNode;
    selected?: boolean;
} & Omit<DropdownMenuItemProps, 'children'>;

// KATS: this can probably be removed since DropdownMenuItem has an
// isSelected prop which basically does the same thing
/**
 * @deprecated use DropdownMenuItem with isSelected prop instead
 */
export const DropdownMenuItemSelectable = ({
    text,
    before,
    selected = false,
    ...props
}: DropdownMenuItemSelectableProps) => {
    return (
        <DropdownMenuItem {...props}>
            {before}
            <span
                className={classNames(
                    'flex-grow-1 text-left',
                    selected && 'font-weight-bold'
                )}>
                {text}
            </span>
            {selected && <CheckIcon className="icon" />}
        </DropdownMenuItem>
    );
};
